import * as G from 'io-ts/Guard'

export type CollectionChildNodeType =
  | 'collection'
  | 'event'
  | 'video'
  | 'article'
  | 'ranking'
  | 'result'
  | 'team'
  | 'person'
  | 'supporter'
  | 'grappling'
  | 'experience-grappling'

export const CollectionChildNodeTypeGuard: G.Guard<unknown, CollectionChildNodeType> = G.literal(
  'collection',
  'event',
  'video',
  'article',
  'ranking',
  'result',
  'team',
  'person',
  'supporter',
  'grappling',
  'experience-grappling'
)
